<template>
    <div>
        <p-search-screen
            title="Credit Requests"
            api-destination="creditrequests"
            edit-key="creditRequestId"
            :filters="filters"
            :fields="fields"
            :filter-by="filterBy"
            :use-bootstrap-selection="false"
            ref="searchScreen"
            add-new-button
            @selected="onSelection"
        >
            <template v-slot:actionButtons>
                <b-dropdown
                    text="Exports"
                    variant="outline-primary">
                    <b-dropdown-item v-b-modal.returnsPickListModal>
                        Returns Pick List
                    </b-dropdown-item>
                </b-dropdown>
            </template>
            <template v-slot:belowSearch>
                <b-row>
                    <p-checkbox
                        label="Proposed"
                        v-model="filters.proposed"
                    />
                    <p-checkbox
                        label="Open"
                        v-model="filters.open"
                    />
                    <p-checkbox
                        label="Closed"
                        v-model="filters.closed"
                    />
                    <b-col>
                        <p-datepicker
                            label="Create Date: From"
                            vid="beginDate"
                            v-model="filters.beginDate"
                        />
                    </b-col>
                    <b-col>
                        <p-datepicker
                            label="Create Date: To"
                            v-model="filters.endDate"
                            rules="dateGreaterOrEqual:@beginDate"
                            is-end-date
                        />
                    </b-col>
                </b-row>
            </template>
        </p-search-screen>
        <p-modal
            name="returnsPickListModal"
            label="Returns Pick List"
            @hide="resetPickList">
            <template v-slot:default>
                <p-form>
                    <div class="container-fluid content-wrapper">
                        <b-row>
                            <b-col>
                                <p-datepicker
                                    label="Invoice Expiration Date: From"
                                    vid="picklistStartDate"
                                    v-model="picklist.startDate"
                                />
                            </b-col>
                            <b-col>
                                <p-datepicker
                                    label="Invoice Expiration Date: To"
                                    v-model="picklist.endDate"
                                    rules="dateGreaterOrEqual:@picklistStartDate"
                                    is-end-date
                                />
                            </b-col>
                        </b-row>
                    </div>
                </p-form>
            </template>
            <template v-slot:modal-footer>
                <b-row>
                    <b-col>
                        <p-button
                            @click="$bvModal.hide('returnsPickListModal')"
                            variant="outline-primary">Cancel</p-button>
                        <b-overlay
                            :show="isBusy"
                            rounded
                            opacity="0.5"
                            spinner-small
                            spinner-variant="primary"
                            class="d-inline-block ms-2">
                            <p-button
                                variant="primary"
                                @click="exportPickList">Export</p-button>
                        </b-overlay>
                    </b-col>
                </b-row>
            </template>
        </p-modal>
    </div>
</template>

<script>
import axios from 'axios';
import {
    currencyFormatter,
    dateFormatter
} from '../../components/Common/Formatters.js';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'CreditRequestFilter',
            selectedCreditRequests: [],
            isBusy: false,
            picklist: {
                startDate: null,
                endDate: null
            },
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'createDate',
                sortDesc: true,
                beginDate: null,
                endDate: null,
                closed: false,
                proposed: true,
                open: true,
                searchBy: 'All'
            },
            filterBy: [
                'All',
                'Request #',
                'Supplier',
                'Invoice #',
                'SKU',
                'Barcode',
                'ISBN',
                'Catalog #'
            ],
            fields: [
                {
                    key: 'requestNumber',
                    sortable: true
                },
                {
                    key: 'supplier',
                    sortable: true
                },
                {
                    key: 'createDate',
                    sortable: true,
                    formatter: dateFormatter
                },
                {
                    key: 'total',
                    thClass: 'text-end',
                    tdClass: 'text-end',
                    formatter: currencyFormatter,
                    sortable: false
                },
                {
                    key: 'status',
                    sortable: true
                }
            ]
        };
    },
    methods: {
        onSelection(creditRequests) {
            this.selectedCreditRequests = creditRequests;
        },
        exportPickList() {
            this.isBusy = true;
            let payload = {
                invoiceExpirationStartDate: this.picklist.startDate,
                invoiceExpirationEndDate: this.picklist.endDate,
                creditRequestIds: this.selectedCreditRequests.map(x => x.creditRequestId)
            };
            axios
                .post('/creditrequests/exportpicklist', payload, { responseType: 'text/html' })
                .then(result => {
                    var newTab = window.open();
                    newTab.document.write(result.data);
                    newTab.document.title = 'Returns Pick List';
                    newTab.document.close();
                    this.$appSuccess('Returns Pick List generated successfully.');
                    this.$bvModal.hide('returnsPickListModal');
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        resetPickList() {
            this.picklist = {
                startDate: null,
                endDate: null
            };
        }
    }
};

</script>
